<template>
    <v-layout>
        <v-tooltip left>
            <v-btn
                    class="truncate-content"
                    slot="activator"
                    absolute
                    dark
                    fab
                    bottom
                    right
                    color="info"
                    @click="dialog = true"
                    style="bottom: -14px !important; right: -14px !important;"
            >
                <v-icon>fas fa-angle-double-right</v-icon>
            </v-btn>
            <span>Detalle completo</span>
        </v-tooltip>
        <v-dialog
                v-model="dialog"
                width="1200"
        >
            <card-basica-tecnologia-entrega :key-tecnologia="keyTecnologia" :prescripcion="prescripcion" :item="item" slot-full></card-basica-tecnologia-entrega>
        </v-dialog>
    </v-layout>
</template>

<script>
    export default {
        name: 'DialogFullTecnologiaEntrega',
        props: {
            item: {
                type: Object,
                default: null
            },
            prescripcion: {
                type: Object,
                default: null
            },
            keyTecnologia: {
                type: String,
                default: 'medicamentos'
            }
        },
        components: {
            CardBasicaTecnologiaEntrega: () => import('@/components/Prescripciones/ServiciosTecnologias/CardBasicaTecnologiaEntrega')
        },
        data: () => ({
            dialog: false
        })
    }
</script>

<style scoped>

</style>